export enum EditModeContextDispatchActionType {
	SetMouseUpCallbackName,
	ToggleMouseUpTrigger,
	UndoRedoTriggerToggle,
	setEditModeDayOffset,
}
